import { render, staticRenderFns } from "./basemessage.vue?vue&type=template&id=a4e3e1a6&scoped=true&"
import script from "./basemessage.vue?vue&type=script&lang=js&"
export * from "./basemessage.vue?vue&type=script&lang=js&"
import style0 from "./basemessage.vue?vue&type=style&index=0&id=a4e3e1a6&scoped=true&lang=css&"
import style1 from "./basemessage.vue?vue&type=style&index=1&id=a4e3e1a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e3e1a6",
  null
  
)

export default component.exports